import React from 'react'

export default function Footer(props) {
  return (
    <footer className="container">
      <span className="block my-10 lg:my-[4.5rem] text-center text-[0.75rem] text-subtle">
        &#169; Huy Phu. All rights reserved | Views: {props.visits}
      </span>
    </footer>
  )
}
